import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { IconButton } from '../../../../components/Button/IconButton';
import { StyledPickerHeader } from '../styles';

export const StyledCompetitorPickerOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  padding: 24px 20px;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(6px);
  border-radius: inherit;
  overflow-y: auto;

  ${StyledPickerHeader} {
    margin-bottom: 16px;
  }
`;

export const StyledCompetitorLabel = styled.div`
  ${setFontVariant('listItem3', colorsPalettes.carbon[300])};
  margin-bottom: 10px;
`;

export const StyledCompetitorSearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid ${colorsPalettes.carbon[100]};
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 8px;
  background: ${colorsPalettes.carbon[0]};

  &:focus-within {
    border-color: ${colorsPalettes.blue[400]};
  }

  svg {
    width: 18px;
    height: 18px;
    color: ${colorsPalettes.carbon[200]};
    flex-shrink: 0;
  }

  input {
    flex: 1;
    border: none;
    outline: none;
    ${setFontVariant('body2', colorsPalettes.carbon[500])};
    background: transparent;

    &::placeholder {
      color: ${colorsPalettes.carbon[200]};
    }
  }
`;

export const StyledCompetitorList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCompetitorRemoveButton = styled(IconButton)`
  width: 28px;
  height: 28px;
  min-width: 28px;
  min-height: 28px;
  padding: 0;
  border-radius: 50%;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
`;

export const StyledCompetitorRemoveWrap = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`;

export const StyledCompetitorItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid ${colorsPalettes.carbon[50]};

  &:last-child {
    border-bottom: none;
  }

  ${StyledCompetitorRemoveWrap} {
    visibility: hidden;
  }

  &:hover ${StyledCompetitorRemoveWrap} {
    visibility: visible;
  }
`;

export const StyledCompetitorIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  background-color: ${colorsPalettes.carbon[0]};
  border: 0.5px solid rgba(214, 219, 225, 1);
  border-radius: 4.5px;
  flex-shrink: 0;
`;

export const StyledCompetitorName = styled.div`
  flex: 1;
  ${setFontVariant('report', colorsPalettes.carbon[500])};
`;

export const StyledCompetitorSuggestions = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: ${colorsPalettes.carbon[0]};
  border: 1px solid ${colorsPalettes.carbon[100]};
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(14, 30, 62, 0.1);
  margin-top: 4px;
  max-height: 180px;
  overflow-y: auto;
  z-index: 10;
`;

export const StyledCompetitorSuggestionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.12s;
  ${setFontVariant('body2', colorsPalettes.carbon[500])};

  &:hover {
    background: ${colorsPalettes.bluegrey[100]};
  }
`;

export const StyledCompetitorSuggestionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  background-color: ${colorsPalettes.carbon[0]};
  border: 0.5px solid rgba(214, 219, 225, 1);
  border-radius: 4.5px;
  flex-shrink: 0;
`;

export const StyledCompetitorApplyWrap = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  padding-top: 16px;
`;
